import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  BelongsToReferenceField,
  FieldTypes,
  dateField,
  OptionTypeFields,
} from 'drapcode-constant';
import { convertTimeStampToDate, formatTimepicker } from '../../../../common/utils/dateUtils';
import ItemMultiFileIcon from './ItemMultiFileIcon';
import { CUSTOM_SEPARATOR } from '../../../../common/utils/field-options';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import {
  eImageTypes,
  fileActivityTrackerLogs,
  getInstalledPlugins,
} from '../../../../common/utils/fileUploadUtils';

const {
  boolean,
  file,
  image,
  multi_image,
  dynamic_option,
  static_option,
  number,
  time_slot,
  object,
  time_picker,
  json,
} = FieldTypes;

class ItemListRecordColumn extends Component {
  static propTypes = {
    field: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { field, item } = this.props;
  }

  async downloadFile(itemId, fileId, collectionName, collectionField, originalName) {
    try {
      const { projectId, version, iPlugins } = this.props;
      const data = {
        itemId: itemId,
        fileId: fileId,
        collectionName: collectionName,
        collectionField: collectionField,
      };
      const eUrl = process.env.REACT_APP_BUILDER_ENGINE;
      const headers = builderSurfaceJsonContentHeader(projectId);
      headers.responseType = 'blob';
      const response = await axios.post(`${eUrl}file/fetch`, data, headers);
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = originalName;
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      const isFileTrackerPluginExists = await getInstalledPlugins(iPlugins);
      if (isFileTrackerPluginExists === true) {
        const fileData = {
          collectionName: collectionName,
          collectionField: collectionField,
          originalName: originalName,
        };
        fileActivityTrackerLogs('Download', projectId, fileData, version);
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  }

  columnValue = (item, field) => {
    const { s3Url, projectDetail } = this.props;
    const { dateFormat } = projectDetail;
    const fieldValue = item[field.fieldName];
    if (field.type === boolean.id) {
      return fieldValue ? 'True' : 'False';
    }
    if (field.type === number.id) {
      return fieldValue || '0';
    }
    if (!fieldValue) {
      return '';
    }

    if (field.type === file.id) {
      if (Array.isArray(fieldValue)) {
        if (fieldValue.length === 1) {
          return this.renderSingleImageAndFiles(item, fieldValue[0], s3Url);
        } else {
          const { projectId, version } = this.props;
          return fieldValue.length > 1 ? (
            <ItemMultiFileIcon
              files={fieldValue}
              downloadFile={this.downloadFile}
              projectId={projectId}
              version={version}
              item={item}
              s3Url={s3Url}
            />
          ) : (
            ''
          );
        }
      } else {
        if (typeof fieldValue === 'object' && fieldValue.hasOwnProperty('mimeType')) {
          return this.renderSingleImageAndFiles(item, fieldValue, s3Url);
        }
      }
    }
    if (field.type === image.id) {
      if (typeof fieldValue === 'object') {
        const key = fieldValue.key;
        return (
          <>
            {s3Url}
            <img src={`${s3Url}${key}`} className="item-table-image" />;
          </>
        );
      } else {
        return '';
      }
    }
    if (field.type === multi_image.id) {
      return Array.isArray(fieldValue)
        ? fieldValue.map((file) => {
            if (file && file.mimeType === 'image/png') {
              return <img src={`${s3Url}${file.key}`} className="item-table-image" />;
            }
          })
        : '';
    }
    if (BelongsToReferenceField.includes(field.type)) {
      const { collectionField } = field.refCollection;
      let innerItems = fieldValue;
      if (collectionField && collectionField.includes(CUSTOM_SEPARATOR)) {
        let refCollectionName = '';
        let refCollectionMeta = collectionField.split(CUSTOM_SEPARATOR);
        refCollectionName = refCollectionMeta[0];
      }

      if (field.isMultiSelect) {
        return innerItems ? innerItems.length : '';
      } else if (innerItems && Array.isArray(innerItems)) {
        const items = innerItems.map((item) => item[collectionField]);
        return this.extractValue(items);
      }
    }
    if (OptionTypeFields.includes(field.type)) {
      return fieldValue ? this.extractValue(fieldValue) : '';
    }

    if ([...dateField, time_slot.id].includes(field.type)) {
      if (!fieldValue || fieldValue === 'undefined' || fieldValue === 'null') return '';
      return convertTimeStampToDate(fieldValue, dateFormat);
    }
    if ([time_picker.id].includes(field.type)) {
      return formatTimepicker(fieldValue, field);
    }

    if ([object.id, json.id].includes(field.type)) {
      return JSON.stringify(fieldValue);
    }
    return ['undefined', 'null', undefined, null].includes(fieldValue) ? '' : fieldValue;
  };

  extractValue = (itemValue) => {
    if (Array.isArray(itemValue)) {
      return itemValue.join(',');
    }
    return itemValue;
  };

  renderSingleImageAndFiles = (item, file, s3Url) => {
    if (['image/png', 'image/jpeg', 'image/jpg'].includes(file.mimeType)) {
      return (
        <img
          src={
            file.isExternalUrl
              ? file.url
              : file.isPrivate === true
              ? file.smallIcon
                ? file.smallIcon
                : 'https://drapcode-static.s3.amazonaws.com/img/placeholder-img.png'
              : `${s3Url}${file.key}`
          }
          className="item-table-image"
          onClick={() =>
            file.isPrivate === true
              ? this.downloadFile(
                  item.uuid,
                  file.uuid,
                  file.collectionName,
                  file.collectionField,
                  file.originalName,
                )
              : undefined
          }
        />
      );
    } else {
      return (
        <a
          className="file-icon-col-flex"
          href={file.isPrivate === false ? `${s3Url}${file.key}` : undefined}
          onClick={() =>
            file.isPrivate === true
              ? this.downloadFile(
                  item.uuid,
                  file.uuid,
                  file.collectionName,
                  file.collectionField,
                  file.originalName,
                )
              : undefined
          }
        >
          <i className="webconnect webconnect-file-alt multi-file-icon-icon"></i>
          <p>{file.originalName}</p>
        </a>
      );
    }
  };

  render() {
    const { field, item } = this.props;
    return <td>{this.columnValue(item, field)}</td>;
  }
}

export default ItemListRecordColumn;
